import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import "../styles/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3>MACROMATRIX (PRIVATE) LIMITED</h3>
          <p>
            Office No 4-A-I Commercial Area, PGEHS, Lahore, Pakistan <br />
            7th Floor, Opal Tower, 701–705, BJK Blvd, Business Bay, Dubai – UAE
          </p>
        </div>

        <div className="footer-column">
          <h3>Company</h3>
          <ul>
            <li>
              <a href="/company">About Us</a>
            </li>
            <li>
              <a href="/services">Services</a>
            </li>
            <li>
              <a href="/portfolio">Portfolio</a>
            </li>
            <li>
              <a href="/apps">Apps</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
            <li>
              <a href="/careers">Careers</a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Information</h3>
          <ul>
            <li>
              <a href="/privacypolicy">Privacy Policy</a>
            </li>
            <li>
              <a href="/termsofservices">Terms of Service</a>
            </li>
            {/* <li>
              <a href="/partners">Members</a>
            </li> */}
          </ul>
        </div>

        <div className="footer-column social-icons">
          <h3>Follow Us</h3>
          <div>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.instagram.com/macro.matrix/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} MACROMATRIX PVT LIMITED. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
